export enum StripeBankAccountStatus {
  /** Account is not in Stripe yet. */
  NotLinked = 'NotLinked',
  /** Created in Stripe; awaiting Stripe's ownership confirmation. */
  Linked = 'Linked',
  /** LEGACY: debit/Customer status; does not occur in the payout flow. */
  PendingVerification = 'PendingVerification',
  /** Stripe confirmed account ownership ("ready"). */
  Verified = 'Verified',
  /** Needs action: a payout failed or ownership verification failed. */
  Failed = 'Failed'
}

export const StripeBankAccountStatusLabels: Record<
  StripeBankAccountStatus,
  string
> = {
  [StripeBankAccountStatus.NotLinked]: 'Not linked',
  [StripeBankAccountStatus.Linked]: 'Linked to Stripe',
  [StripeBankAccountStatus.PendingVerification]: 'Verification pending',
  [StripeBankAccountStatus.Verified]: 'Verified',
  [StripeBankAccountStatus.Failed]: 'Action needed'
};
